import { render } from "./FacultyLoadDialog.vue?vue&type=template&id=7149a748&scoped=true"
import script from "./FacultyLoadDialog.vue?vue&type=script&lang=js"
export * from "./FacultyLoadDialog.vue?vue&type=script&lang=js"

import "./FacultyLoadDialog.vue?vue&type=style&index=0&id=7149a748&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7149a748"]])

export default __exports__